import { Badge } from "reactstrap";
import {
  FaCheckCircle,
  FaUsers,
  FaUniversity,
  FaPercent,
} from "react-icons/fa";
import { GroupDto } from "../../types/Group";

interface Props {
  group: GroupDto;
}

const CourseHeroSection = ({ group }: Props) => {
  return (
    <div className="py-lg-12 py-4">

      <Badge
        color="light"
        pill
        className="px-3 text-muted py-2 mb-3"
      >
        Student Learning Group
      </Badge>

      <h1
        className="fw-bold mb-3"
        style={{
          fontSize: "clamp(2rem,5vw,3.2rem)",
          lineHeight: 1.2,
        }}
      >
        {group.groupName}
      </h1>

      <h3
        className="fw-semibold text-primary mb-4"
        style={{
          fontSize: "clamp(1.1rem,2vw,1.5rem)",
        }}
      >
        Join Together. Negotiate Better. Save More.
      </h3>

      <p
        className="text-muted"
        style={{
          maxWidth: "1050px",
          fontSize: "1.08rem",
          lineHeight: "1.8",
        }}
      >
       <strong> Planning to join a{" "}
        {group.groupName} coaching institute? </strong>
        <br/>Don't negotiate alone. Join a group of students with the same goal and unlock exclusive group discounts from top coaching institutes.
        <br/>Compare coaching quality, fees, faculty, facilities, and student reviews—all in one place—before making your final decision.
        <br/><strong>Join together. Negotiate better. Save more.</strong>
      </p>

      <div className="row mt-4 gy-3">

        <div className="col-md-6">
          <div className="d-flex align-items-start">
            <FaPercent
              className="text-success mt-1 me-3"
              size={20}
            />

            <div>
              <h6 className="fw-bold mb-1">
                Better Group Discounts
              </h6>

              <small className="text-muted">
                The bigger the group,the better the price and discounts.
              </small>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="d-flex align-items-start">
            <FaUniversity
              className="text-primary mt-1 me-3"
              size={20}
            />

            <div>
              <h6 className="fw-bold mb-1">
                Compare Institutes
              </h6>

              <small className="text-muted">
                Review offers, faculty, fees and student
                experiences before enrolling.
              </small>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="d-flex align-items-start">
            <FaUsers
              className="text-warning mt-1 me-3"
              size={20}
            />

            <div>
              <h6 className="fw-bold mb-1">
                Discuss and choose together
              </h6>

              <small className="text-muted">
                Connect with students preparing for the
                same course and share useful insights.
              </small>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="d-flex align-items-start">
            <FaCheckCircle
              className="text-success mt-1 me-3"
              size={20}
            />

            <div>
              <h6 className="fw-bold mb-1">
                Free to Join
              </h6>

              <small className="text-muted">
                No commitment. Join the discussion and
                leave anytime before enrollment.
              </small>
            </div>
          </div>
        </div>

      </div>

    </div>
  );
};

export default CourseHeroSection;